import { configureStore } from '@reduxjs/toolkit'
import loginSlice from './slices/login'
import applicationsSlice from './slices/aplications'
import endpointsSlice from './slices/endpoint'
import glossarySlice from './slices/glossary'
import uiSlice from './slices/ui'


const store = configureStore({
  reducer: {
    login: loginSlice.reducer,
    applications: applicationsSlice.reducer,
    endpoints: endpointsSlice.reducer,
    ui: uiSlice.reducer,
    glossary: glossarySlice.reducer,
  },
  devTools: process.env.NODE_ENV !== 'production'
})

export default store